import {useModule} from "./useModule";


const useORM = () => {
    return useModule("orm");
};


export {useORM};